import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as referenceSchemeActions from '../store/reference-scheme.actions';

@Injectable({
  providedIn: 'root',
})
export class ReferenceSchemeOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(referenceSchemeActions.loadData());
    return of(true);
  }
}
